
import { useState } from 'react';
import Header from '../../components/base/Header';
import Footer from '../../components/base/Footer';

interface CelebrationFlower {
  id: number;
  name: string;
  englishName: string;
  occasion: string;
  meanings: string[];
  colors: string[];
  season: string;
  priceRange: string;
  image: string;
  description: string;
  giftTips: string[];
  arrangements: string[];
  symbolism: string;
}

const celebrationFlowers: CelebrationFlower[] = [
  {
    id: 1,
    name: '胡蝶蘭',
    englishName: 'Phalaenopsis',
    occasion: '開店祝い・就任祝い・新築祝い',
    meanings: ['幸福が飛んでくる', '純粋な愛', '上品', '美しい淑女'],
    colors: ['白', 'ピンク', '黄色', '紫'],
    season: '通年',
    priceRange: '¥10,000〜¥50,000',
    image: 'https://public.readdy.ai/ai/img_res/d8c45a4e9456991ff69b1ff60bdb1e1b.jpg',
    description: 'お祝いの定番として最も人気の高い胡蝶蘭。その優雅な姿と「幸福が飛んでくる」という花言葉から、ビジネスシーンでの贈り物として重宝されています。',
    giftTips: [
      '3本立ち以上が一般的',
      '白色が最もフォーマル',
      '立札やメッセージカードを添える',
      '配送日時の調整が重要'
    ],
    arrangements: ['3本立ち', '5本立ち', '7本立ち', 'ミニ胡蝶蘭'],
    symbolism: '成功と繁栄の象徴として、新しいスタートを祝福する最高の贈り物です。'
  },
  {
    id: 2,
    name: 'スタンド花',
    englishName: 'Standing Flower Arrangement',
    occasion: '開店祝い・公演祝い・展示会',
    meanings: ['祝福', '成功', '繁栄', '応援'],
    colors: ['赤', 'ピンク', '黄色', 'ミックス'],
    season: '通年',
    priceRange: '¥15,000〜¥30,000',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20standing%20flower%20arrangement%20for%20grand%20opening%20celebration%2C%20vibrant%20mixed%20flowers%20in%20elegant%20stand%2C%20professional%20congratulatory%20display%2C%20business%20celebration%20setting%2C%20eye-catching%20floral%20design&width=400&height=300&seq=celebration-stand-1&orientation=landscape',
    description: '華やかで目を引くスタンド花は、開店祝いや公演祝いに最適。遠くからでも目立つため、お祝いの気持ちを大きくアピールできます。',
    giftTips: [
      '設置場所の確認が必要',
      '回収サービスを利用する',
      '店名や会社名を入れる',
      '周囲との調和を考慮'
    ],
    arrangements: ['1段スタンド', '2段スタンド', 'バルーン付き', 'ライト付き'],
    symbolism: '新しい門出を華やかに彩り、多くの人に祝福の気持ちを伝える象徴的な贈り物です。'
  },
  {
    id: 3,
    name: 'バラの花束',
    englishName: 'Rose Bouquet',
    occasion: '結婚祝い・記念日・プロポーズ',
    meanings: ['愛', '美', '情熱', '尊敬'],
    colors: ['赤', 'ピンク', '白', '黄色'],
    season: '通年',
    priceRange: '¥5,000〜¥20,000',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20red%20rose%20bouquet%20for%20wedding%20celebration%2C%20elegant%20romantic%20arrangement%20with%20ribbon%2C%20luxury%20gift%20presentation%2C%20love%20and%20romance%20theme%2C%20professional%20flower%20photography&width=400&height=300&seq=celebration-roses-1&orientation=landscape',
    description: '愛の象徴として親しまれるバラは、結婚祝いや記念日に欠かせない花。色によって異なる意味を持ち、贈る相手への気持ちを表現できます。',
    giftTips: [
      '本数に意味がある（12本=愛の告白）',
      '色の意味を理解して選ぶ',
      '保水処理をしてもらう',
      'メッセージカードを添える'
    ],
    arrangements: ['ラウンドブーケ', 'カスケードブーケ', 'クラッチブーケ', 'バスケット'],
    symbolism: '永遠の愛と美しさを象徴し、人生の特別な瞬間を彩る最も古典的で美しい贈り物です。'
  },
  {
    id: 4,
    name: 'ガーベラアレンジメント',
    englishName: 'Gerbera Arrangement',
    occasion: '誕生日・卒業祝い・快気祝い',
    meanings: ['希望', '常に前進', '神秘', '崇高美'],
    colors: ['オレンジ', 'ピンク', '黄色', '赤'],
    season: '通年',
    priceRange: '¥3,000〜¥8,000',
    image: 'https://readdy.ai/api/search-image?query=Bright%20colorful%20gerbera%20flower%20arrangement%20for%20birthday%20celebration%2C%20cheerful%20mixed%20colors%20in%20decorative%20vase%2C%20happy%20celebration%20theme%2C%20vibrant%20flower%20display%2C%20joyful%20gift%20presentation&width=400&height=300&seq=celebration-gerbera-1&orientation=landscape',
    description: '明るく元気な印象のガーベラは、誕生日や卒業祝いなど、喜びを表現したい場面に最適。カラフルな色合いで空間を明るく演出します。',
    giftTips: [
      '明るい色を選ぶ',
      '複数色を組み合わせる',
      'カジュアルな贈り物に最適',
      '花持ちが良い'
    ],
    arrangements: ['ラウンドアレンジ', 'バスケットアレンジ', 'ボックスアレンジ', 'ブーケ'],
    symbolism: '希望と前向きなエネルギーを象徴し、新しいスタートや成功を祝福する明るい贈り物です。'
  },
  {
    id: 5,
    name: 'ユリのアレンジメント',
    englishName: 'Lily Arrangement',
    occasion: '結婚祝い・新築祝い・お悔やみ',
    meanings: ['純粋', '無垢', '威厳', '高貴'],
    colors: ['白', 'ピンク', '黄色', 'オレンジ'],
    season: '春〜夏',
    priceRange: '¥4,000〜¥12,000',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20white%20lily%20arrangement%20for%20wedding%20celebration%2C%20pure%20and%20sophisticated%20floral%20display%2C%20formal%20gift%20presentation%2C%20classic%20flower%20arrangement%2C%20luxury%20wedding%20flowers&width=400&height=300&seq=celebration-lily-1&orientation=landscape',
    description: '純粋さと高貴さを象徴するユリは、結婚祝いや重要な祝い事に相応しい花。その上品な香りと美しい姿で、特別な日を演出します。',
    giftTips: [
      '香りが強いので注意',
      '花粉を取り除く',
      'フォーマルな場面に適している',
      '白色が最も人気'
    ],
    arrangements: ['スタンディングアレンジ', 'テーブルアレンジ', 'ブライダルブーケ', 'カサブランカ'],
    symbolism: '純潔と神聖さを表し、人生の重要な節目や神聖な儀式を美しく彩る格式高い贈り物です。'
  },
  {
    id: 6,
    name: 'カーネーションブーケ',
    englishName: 'Carnation Bouquet',
    occasion: '母の日・感謝の気持ち・退職祝い',
    meanings: ['無垢で深い愛', '母への愛', '感謝', '尊敬'],
    colors: ['赤', 'ピンク', '白', '黄色'],
    season: '通年',
    priceRange: '¥2,000〜¥6,000',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20pink%20carnation%20bouquet%20for%20mothers%20day%20celebration%2C%20loving%20gift%20presentation%20with%20ribbon%2C%20appreciation%20and%20gratitude%20theme%2C%20warm%20family%20celebration%2C%20heartfelt%20flower%20arrangement&width=400&height=300&seq=celebration-carnation-1&orientation=landscape',
    description: '母の日の定番として愛されるカーネーション。感謝の気持ちを表現するのに最適で、温かい愛情を伝える花として親しまれています。',
    giftTips: [
      '赤は母への愛を表す',
      'ピンクは感謝の気持ち',
      '白は亡き母への愛',
      '花持ちが良い'
    ],
    arrangements: ['ラウンドブーケ', 'スプレーカーネーション', 'ミックスブーケ', 'バスケット'],
    symbolism: '母性愛と感謝の象徴として、家族への深い愛情と尊敬の気持ちを表現する温かい贈り物です。'
  },
  {
    id: 7,
    name: 'ひまわりアレンジメント',
    englishName: 'Sunflower Arrangement',
    occasion: '夏の祝い事・元気づけ・応援',
    meanings: ['憧れ', '愛慕', '崇拝', '情熱'],
    colors: ['黄色', 'オレンジ', '赤茶'],
    season: '夏',
    priceRange: '¥3,000〜¥8,000',
    image: 'https://readdy.ai/api/search-image?query=Bright%20yellow%20sunflower%20arrangement%20for%20summer%20celebration%2C%20cheerful%20and%20energetic%20floral%20display%2C%20warm%20sunshine%20theme%2C%20encouraging%20gift%20presentation%2C%20vibrant%20summer%20flowers&width=400&height=300&seq=celebration-sunflower-1&orientation=landscape',
    description: '太陽のように明るく元気なひまわりは、夏の祝い事や応援の気持ちを表現するのに最適。見る人に元気と希望を与える力強い花です。',
    giftTips: [
      '夏季限定の花',
      '元気づけたい時に最適',
      '大きなサイズが印象的',
      'カジュアルな贈り物に'
    ],
    arrangements: ['ナチュラルブーケ', 'カントリーアレンジ', 'バスケットアレンジ', 'ミニひまわり'],
    symbolism: '太陽のエネルギーと希望を象徴し、困難に立ち向かう勇気と前向きな気持ちを贈る力強い花です。'
  },
  {
    id: 8,
    name: 'トルコキキョウブーケ',
    englishName: 'Lisianthus Bouquet',
    occasion: '結婚祝い・記念日・お見舞い',
    meanings: ['優美', '希望', '変わらぬ美しさ', '感謝'],
    colors: ['白', 'ピンク', '紫', '黄色'],
    season: '通年',
    priceRange: '¥4,000〜¥10,000',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20purple%20lisianthus%20bouquet%20for%20anniversary%20celebration%2C%20sophisticated%20floral%20arrangement%2C%20romantic%20gift%20presentation%2C%20delicate%20ruffled%20petals%2C%20luxury%20flower%20display&width=400&height=300&seq=celebration-lisianthus-1&orientation=landscape',
    description: 'バラのような美しい花形と上品な色合いが魅力のトルコキキョウ。結婚祝いや記念日など、特別な日の贈り物として人気があります。',
    giftTips: [
      'バラに似た豪華な見た目',
      '花持ちが非常に良い',
      '上品で洗練された印象',
      '様々な色が楽しめる'
    ],
    arrangements: ['ブライダルブーケ', 'ラウンドアレンジ', 'カスケードブーケ', 'ミックスブーケ'],
    symbolism: '永続する美しさと優雅さを表し、変わらぬ愛情と感謝の気持ちを伝える洗練された贈り物です。'
  },
  {
    id: 9,
    name: 'かすみ草ブーケ',
    englishName: 'Baby\'s Breath Bouquet',
    occasion: '結婚祝い・出産祝い・清楚な贈り物',
    meanings: ['清らかな心', '無邪気', '親切', '幸福'],
    colors: ['白', 'ピンク'],
    season: '通年',
    priceRange: '¥2,000〜¥5,000',
    image: 'https://readdy.ai/api/search-image?query=Pure%20white%20baby%20breath%20bouquet%20for%20wedding%20celebration%2C%20delicate%20cloud-like%20flowers%2C%20innocent%20and%20pure%20gift%20presentation%2C%20minimalist%20elegant%20arrangement%2C%20soft%20romantic%20atmosphere&width=400&height=300&seq=celebration-babysbreath-1&orientation=landscape',
    description: '小さな白い花が雲のように咲くかすみ草は、清純さと無邪気さを表現する花。結婚祝いや出産祝いなど、純粋な喜びを表現したい時に最適です。',
    giftTips: [
      '他の花との組み合わせも人気',
      '清楚で上品な印象',
      'ドライフラワーにもできる',
      'リーズナブルな価格'
    ],
    arrangements: ['単体ブーケ', 'ミックスブーケ', 'ドライフラワー', 'ヘアアクセサリー'],
    symbolism: '純真無垢な心と清らかな愛を象徴し、新しい生命や純粋な愛情を祝福する清楚な贈り物です。'
  },
  {
    id: 10,
    name: 'アンスリウムアレンジメント',
    englishName: 'Anthurium Arrangement',
    occasion: '開店祝い・新築祝い・モダンな贈り物',
    meanings: ['情熱', '印象深い', '無垢な心', '炎のような輝き'],
    colors: ['赤', 'ピンク', '白', '緑'],
    season: '通年',
    priceRange: '¥5,000〜¥12,000',
    image: 'https://readdy.ai/api/search-image?query=Modern%20red%20anthurium%20arrangement%20for%20business%20celebration%2C%20tropical%20exotic%20flowers%20in%20contemporary%20vase%2C%20sophisticated%20gift%20presentation%2C%20sleek%20modern%20design%2C%20luxury%20tropical%20flowers&width=400&height=300&seq=celebration-anthurium-1&orientation=landscape',
    description: 'ハート型の鮮やかな花が印象的なアンスリウム。モダンで洗練された印象を与え、現代的なオフィスや店舗の開店祝いに人気があります。',
    giftTips: [
      'モダンでスタイリッシュ',
      '花持ちが非常に良い',
      '熱帯植物の魅力',
      '個性的な贈り物に'
    ],
    arrangements: ['モダンアレンジ', 'トロピカルブーケ', 'コンテンポラリー', 'ミニマルデザイン'],
    symbolism: '情熱と革新を象徴し、新しい挑戦や現代的な成功を祝福するスタイリッシュな贈り物です。'
  }
];

const occasions = [
  { id: 'all', name: 'すべて', icon: 'ri-gift-line' },
  { id: 'business', name: 'ビジネス祝い', icon: 'ri-building-line' },
  { id: 'wedding', name: '結婚・記念日', icon: 'ri-heart-line' },
  { id: 'birthday', name: '誕生日', icon: 'ri-cake-line' },
  { id: 'graduation', name: '卒業・入学', icon: 'ri-graduation-cap-line' },
  { id: 'family', name: '家族の祝い', icon: 'ri-home-heart-line' },
  { id: 'sympathy', name: 'お見舞い・励まし', icon: 'ri-hand-heart-line' }
];

const priceRanges = [
  { id: 'all', name: 'すべて', min: 0, max: Infinity },
  { id: 'under5000', name: '5,000円以下', min: 0, max: 5000 },
  { id: '5000to15000', name: '5,000円〜15,000円', min: 5000, max: 15000 },
  { id: 'over15000', name: '15,000円以上', min: 15000, max: Infinity }
];

export default function CelebrationFlowers() {
  const [selectedOccasion, setSelectedOccasion] = useState('all');
  const [selectedPriceRange, setSelectedPriceRange] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedFlower, setSelectedFlower] = useState<CelebrationFlower | null>(null);

  const getOccasionCategory = (occasion: string) => {
    if (occasion.includes('開店') || occasion.includes('就任') || occasion.includes('新築')) return 'business';
    if (occasion.includes('結婚') || occasion.includes('記念日') || occasion.includes('プロポーズ')) return 'wedding';
    if (occasion.includes('誕生日')) return 'birthday';
    if (occasion.includes('卒業') || occasion.includes('入学')) return 'graduation';
    if (occasion.includes('母の日') || occasion.includes('感謝') || occasion.includes('退職') || occasion.includes('出産')) return 'family';
    if (occasion.includes('お見舞い') || occasion.includes('快気') || occasion.includes('元気') || occasion.includes('応援')) return 'sympathy';
    return 'all';
  };

  const filteredFlowers = celebrationFlowers.filter(flower => {
    const matchesOccasion = selectedOccasion === 'all' || getOccasionCategory(flower.occasion) === selectedOccasion;
    const priceRange = priceRanges.find(range => range.id === selectedPriceRange);
    const minPrice = parseInt(flower.priceRange.split('〜')[0].replace(/[¥,]/g, ''));
    const matchesPrice = !priceRange || minPrice >= priceRange.min && minPrice <= priceRange.max;
    const matchesSearch = flower.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         flower.englishName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         flower.occasion.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         flower.meanings.some(meaning => meaning.toLowerCase().includes(searchTerm.toLowerCase()));
    
    return matchesOccasion && matchesPrice && matchesSearch;
  });

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative py-24 bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://readdy.ai/api/search-image?query=Beautiful%20celebration%20flower%20arrangements%20for%20various%20occasions%2C%20elegant%20gift%20bouquets%20and%20arrangements%2C%20professional%20flower%20shop%20display%2C%20congratulatory%20flowers%2C%20luxury%20floral%20gifts%2C%20festive%20atmosphere&width=1920&height=600&seq=celebration-hero&orientation=landscape')`
        }}
      >
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            お祝い用の花
          </h1>
          <p className="text-xl text-white/90 mb-8 max-w-3xl mx-auto leading-relaxed">
            特別な日を美しく彩る、お祝いにぴったりの花をご紹介します。
            <br />
            大切な人への気持ちを花に込めて、心に残る贈り物を選びましょう。
          </p>
        </div>
      </section>

      {/* Search and Filter Section */}
      <section className="py-12 bg-gradient-to-br from-pink-50 to-purple-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            {/* Search Bar */}
            <div className="mb-8">
              <div className="relative max-w-md mx-auto">
                <input
                  type="text"
                  placeholder="花の名前やお祝いの種類で検索..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full px-4 py-3 pl-12 rounded-full border border-gray-200 focus:outline-none focus:ring-2 focus:ring-pink-500 text-sm"
                />
                <i className="ri-search-line absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm"></i>
              </div>
            </div>

            {/* Occasion Filter */}
            <div className="mb-6">
              <h3 className="text-lg font-semibold text-gray-800 mb-4 text-center">お祝いの種類</h3>
              <div className="flex flex-wrap justify-center gap-2">
                {occasions.map((occasion) => (
                  <button
                    key={occasion.id}
                    onClick={() => setSelectedOccasion(occasion.id)}
                    className={`px-4 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                      selectedOccasion === occasion.id
                        ? 'bg-pink-500 text-white'
                        : 'bg-white text-gray-700 hover:bg-pink-100'
                    }`}
                  >
                    <i className={`${occasion.icon} mr-2`}></i>
                    {occasion.name}
                  </button>
                ))}
              </div>
            </div>

            {/* Price Filter */}
            <div>
              <h3 className="text-lg font-semibold text-gray-800 mb-4 text-center">価格帯</h3>
              <div className="flex flex-wrap justify-center gap-3">
                {priceRanges.map((range) => (
                  <button
                    key={range.id}
                    onClick={() => setSelectedPriceRange(range.id)}
                    className={`px-3 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                      selectedPriceRange === range.id
                        ? 'bg-purple-500 text-white'
                        : 'bg-white text-gray-700 hover:bg-purple-100'
                    }`}
                  >
                    {range.name}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Flowers Grid */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">
              {filteredFlowers.length}種類のお祝い花
            </h2>
            <p className="text-gray-600">特別な日にふさわしい美しい花をお選びください</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredFlowers.map((flower) => (
              <div
                key={flower.id}
                className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all cursor-pointer group"
                onClick={() => setSelectedFlower(flower)}
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={flower.image}
                    alt={flower.name}
                    className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm px-2 py-1 rounded-full text-xs font-medium text-gray-700">
                    {flower.season}
                  </div>
                </div>
                <div className="p-6">
                  <div className="flex items-center justify-between mb-3">
                    <h3 className="text-xl font-bold text-gray-800">{flower.name}</h3>
                    <span className="text-sm font-semibold text-green-600">{flower.priceRange}</span>
                  </div>
                  <p className="text-sm text-gray-500 mb-3">{flower.englishName}</p>
                  
                  <div className="mb-4">
                    <div className="text-sm font-medium text-gray-700 mb-2">適用場面</div>
                    <div className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-xs font-medium inline-block">
                      {flower.occasion}
                    </div>
                  </div>

                  <div className="mb-4">
                    <div className="text-sm font-medium text-gray-700 mb-2">花言葉</div>
                    <div className="flex flex-wrap gap-1">
                      {flower.meanings.slice(0, 2).map((meaning, index) => (
                        <span
                          key={index}
                          className="bg-pink-100 text-pink-800 px-2 py-1 rounded-full text-xs font-medium"
                        >
                          {meaning}
                        </span>
                      ))}
                      {flower.meanings.length > 2 && (
                        <span className="text-gray-500 text-xs">+{flower.meanings.length - 2}</span>
                      )}
                    </div>
                  </div>

                  <p className="text-gray-600 text-sm line-clamp-2">{flower.description}</p>
                </div>
              </div>
            ))}
          </div>

          {filteredFlowers.length === 0 && (
            <div className="text-center py-16">
              <i className="ri-search-line text-6xl text-gray-300 mb-4"></i>
              <h3 className="text-xl font-semibold text-gray-600 mb-2">該当する花が見つかりません</h3>
              <p className="text-gray-500">検索条件を変更してお試しください</p>
            </div>
          )}
        </div>
      </section>

      {/* Flower Detail Modal */}
      {selectedFlower && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-3xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
            <div className="relative">
              <img
                src={selectedFlower.image}
                alt={selectedFlower.name}
                className="w-full h-64 object-cover object-center"
              />
              <button
                onClick={() => setSelectedFlower(null)}
                className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm w-10 h-10 rounded-full flex items-center justify-center hover:bg-white transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
            <div className="p-8">
              <div className="flex items-start justify-between mb-6">
                <div>
                  <h2 className="text-3xl font-bold text-gray-800 mb-2">{selectedFlower.name}</h2>
                  <p className="text-gray-500 text-lg">{selectedFlower.englishName}</p>
                </div>
                <div className="text-right">
                  <div className="text-sm text-gray-500 mb-1">価格帯</div>
                  <div className="text-2xl font-bold text-green-600">{selectedFlower.priceRange}</div>
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-8">
                <div>
                  <div className="mb-6">
                    <h3 className="text-xl font-semibold text-gray-800 mb-3">適用場面</h3>
                    <div className="bg-blue-100 text-blue-800 px-4 py-2 rounded-lg font-medium">
                      {selectedFlower.occasion}
                    </div>
                  </div>

                  <div className="mb-6">
                    <h3 className="text-xl font-semibold text-gray-800 mb-3">花言葉</h3>
                    <div className="flex flex-wrap gap-2">
                      {selectedFlower.meanings.map((meaning, index) => (
                        <span
                          key={index}
                          className="bg-pink-100 text-pink-800 px-3 py-2 rounded-full font-medium"
                        >
                          {meaning}
                        </span>
                      ))}
                    </div>
                  </div>

                  <div className="mb-6">
                    <h3 className="text-xl font-semibold text-gray-800 mb-3">利用可能な色</h3>
                    <div className="flex flex-wrap gap-2">
                      {selectedFlower.colors.map((color, index) => (
                        <span
                          key={index}
                          className="bg-gray-100 text-gray-800 px-3 py-1 rounded-full text-sm font-medium"
                        >
                          {color}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>

                <div>
                  <div className="mb-6">
                    <h3 className="text-xl font-semibold text-gray-800 mb-3">贈り物のコツ</h3>
                    <ul className="space-y-2">
                      {selectedFlower.giftTips.map((tip, index) => (
                        <li key={index} className="flex items-start">
                          <i className="ri-check-line text-green-600 mr-2 mt-1"></i>
                          <span className="text-gray-600 text-sm">{tip}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="mb-6">
                    <h3 className="text-xl font-semibold text-gray-800 mb-3">アレンジメント</h3>
                    <div className="flex flex-wrap gap-2">
                      {selectedFlower.arrangements.map((arrangement, index) => (
                        <span
                          key={index}
                          className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium"
                        >
                          {arrangement}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              <div className="mb-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-3">説明</h3>
                <p className="text-gray-600 leading-relaxed">{selectedFlower.description}</p>
              </div>

              <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl p-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-3">象徴的意味</h3>
                <p className="text-gray-600 leading-relaxed">{selectedFlower.symbolism}</p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Gift Guide Section */}
      <section className="py-16 bg-gradient-to-br from-green-50 to-blue-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">お祝い花の贈り方ガイド</h2>
            <p className="text-gray-600">心に残る贈り物をするためのポイント</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="bg-white rounded-2xl p-6 shadow-lg">
              <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center mb-4">
                <i className="ri-calendar-line text-2xl text-pink-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">タイミング</h3>
              <p className="text-gray-600">お祝い事の当日または前日に届くよう手配しましょう。開店祝いは開店日の午前中がベストです。</p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-4">
                <i className="ri-message-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">メッセージ</h3>
              <p className="text-gray-600">心のこもったメッセージカードや立札を添えることで、より気持ちが伝わる贈り物になります。</p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mb-4">
                <i className="ri-map-pin-line text-2xl text-green-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">配送先</h3>
              <p className="text-gray-600">事前に配送先の住所や受け取り可能時間を確認し、確実にお届けできるよう準備しましょう。</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
